// LoadingSpinner.tsx
import React from 'react';

export interface LoadingSpinnerProps {
  /** Diameter in pixels */
  size?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 64 }) => (
  <div
    className="relative"
    style={{ width: size, height: size }}
    role="status"
    aria-label="Loading"
  >
    {/* Pulse backdrop */}
    <div className="absolute inset-0 rounded-full bg-blue-500 opacity-50 animate-ping" />

    {/* Spinner ring */}
    <div
      className="absolute inset-0 rounded-full border-4 border-blue-600 border-t-transparent animate-spin"
    />
  </div>
);
